import cuid from "cuid";
import { blockType } from "../constants";
import { FieldBlockSchema } from "../schema";
import { Field } from "../types";
import { generateFormFieldName } from "lib/utils/generateFieldName";

export const create: Field["create"] = (initialConfig) => {
  return FieldBlockSchema.parse({
    type: blockType,
    config: {
      ...initialConfig,
      id: cuid(),
      name: initialConfig?.name ?? generateFormFieldName(),
      label: initialConfig?.label ?? "Email",
      inputType: initialConfig?.inputType ?? "email",
      required:
        initialConfig?.required !== undefined ? initialConfig.required : true,
      nameAutoGenerated:
        initialConfig?.nameAutoGenerated !== undefined
          ? initialConfig.nameAutoGenerated
          : true,
    },
  });
};
